import { render, staticRenderFns } from "./EmailTest.vue?vue&type=template&id=62fadbfa&"
import script from "./EmailTest.vue?vue&type=script&lang=js&"
export * from "./EmailTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports